import React from 'react'

const Title = ({children}) => {
  return (
    <h2 className="inlineTitle slds-p-top--x-small slds-p-horizontal--medium slds-p-bottom--x-small slds-text-heading--medium">{children}</h2>
  )
}

export default Title
